// Make the app compatible with IE11
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppContextProvider } from './core/context/global/AppContext';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './core/services/api.service';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <AppContextProvider>
    <App />
  </AppContextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
